import type { SmartViewArtifact } from "../../../../api/types/smartViewArtifactsTypes";
import type { ReportAuthorizationInfo } from "../../../../api/types/svTypes";
import ShareReportWrapper from "../report-lists/reports/components/ShareReportWrapper";
import type { SharedReport } from "../sv/components/viewer/common/sharing/ShareReport.types";
import { BiApiClientProvider } from "../sv/contexts/BiApiClientProvider";
import { artifactSharingApiClient } from "./artifactSharingApiClient";

interface Props {
  artifact: SmartViewArtifact;
  name: string;
  onClose: () => void;
  onSharingUpdated: (authorization: ReportAuthorizationInfo, inheritFromParent: boolean) => void;
}

const toSharedReport = (artifact: SmartViewArtifact, name: string): SharedReport => ({
  clientCode: artifact.clientCode,
  reportId: artifact.id,
  name,
  groupId: artifact.groupId,
  authorization: artifact.authorization,
});

const ArtifactShareDialog = ({ artifact, name, onClose, onSharingUpdated }: Props) => (
  <BiApiClientProvider api={artifactSharingApiClient}>
    <ShareReportWrapper
      report={toSharedReport(artifact, name)}
      itemType="dashboard"
      onClose={onClose}
      updateReportAuthorizationInfo={(_, authorization, inheritFromParent) =>
        onSharingUpdated(authorization, inheritFromParent)
      }
    />
  </BiApiClientProvider>
);

export default ArtifactShareDialog;
